<div class="bg-info text-info-contrast flex h-full items-center justify-between px-3">
  <div class="col-span-1 flex justify-center">
    <div class="flex items-center gap-1 text-xs font-bold tracking-wider">
      <edu-icon [icon]="BetaIcon" />
      {{ 'components.atoms.betaBanner.badge' | transloco }}
    </div>
    <h3 class="ml-3 hidden text-xs lg:block">
      {{ 'components.atoms.betaBanner.description' | transloco }}
    </h3>
  </div>
  <div class="col-span-1 flex items-center">
    <a [href]="legacyDashboardUrl" class="text-xs underline">{{
      'components.atoms.betaBanner.link' | transloco
    }}</a>
  </div>
</div>
